import React from "react";
import Translate from "../../../../../../../../components/Translate";
import Input from "../../../../../../../../components-new/form/Input";
import Switch from "../../../../../../../../components-new/form/Switch";
import colors from "../../../../../../../../utils/Colors";
import {isPositiveNonZeroInteger} from "../../../../../../../../utils/General";
import SettingCard from "../../../../../../../../components-new/ui/SettingCard";
import {updateClientWebChatTriggerConf} from "../../../../../../../../services/company/api";

const inputStyle = {width: '100%', border: 'none', height: '38px', background: 'transparent'};

const TriggerSettings = ({triggers, setTriggers, clientId, isFetching}) => {
    const saveTriggers = (updateData) => {
        const updated = {...triggers, ...updateData};
        updateClientWebChatTriggerConf(clientId, updated).then(() => {
            setTriggers(updated);
        });
    };

    const handlePeriodStatusChange = (checked) => {
        const {openAfterPeriod} = triggers;

        const newPeriod = openAfterPeriod === -1 ? 5 : openAfterPeriod;
        saveTriggers(checked ? {openAfterPeriod: newPeriod} : {openAfterPeriod: -1});
    };

    const handlePeriodChange = (e) => {
        saveTriggers({openAfterPeriod: e.target.value});
    };

    const openAfterPeriod = triggers.openAfterPeriod;
    const isDisabled = openAfterPeriod === -1;

    return (
        <SettingCard
            titleKey="settingTheTriggerForStartingTheChat"
            toggle={
                <Switch
                    checked={!isDisabled}
                    onChange={handlePeriodStatusChange}
                    style={{color: colors.silverBlue}}
                />
            }
        >
            <div className={'setting-body setting-body--compact'
                + (isDisabled ? ' setting-body--off' : '')}>
                <div className="setting-number">
                    <div className="setting-number__box">
                        <Input
                            type="number"
                            style={inputStyle}
                            defaultValue={openAfterPeriod}
                            validate={isPositiveNonZeroInteger}
                            onBlur={handlePeriodChange}
                            name="trigger-sec-input"
                            disabled={isDisabled || isFetching}
                        />
                    </div>
                    <span className="setting-number__unit"><Translate text="sec"/></span>
                </div>
            </div>
        </SettingCard>
    );
};

export default TriggerSettings;



// WEBPACK FOOTER //
// ./src/scenes/dashboard/components/management/clients/new/functions/components/TriggerSettings.jsx